import { NgClass } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectButtonModule } from 'primeng/selectbutton';

@Component({
  selector: 'app-form-for-boolean',
  templateUrl: './form-for-boolean.component.html',
  imports: [NgClass, 
    FormsModule,
    SelectButtonModule
  ]
})
export class FormForBooleanComponent implements OnChanges {
  public readonly falseLable = input<string | undefined>($localize `:@@off:Aus`);
  public readonly trueLable = input<string | undefined>($localize `:@@on:An`);
  @Input({ required: true }) public value?: boolean;
  public readonly label = input.required<string>();
  public readonly isDisabled = input<boolean | undefined>(false);
  public readonly colClass = input<string | undefined>('col-3');

  public readonly valueChange = output<boolean>();

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes["value"]) {
      if (!changes["value"].currentValue) {
        this.value = false;
      }
    }
  }

  public get booleanOptions(): { label: string; value: boolean }[] {
    return [
      {
        label: this.falseLable() ?? $localize`:@@off:Aus`,
        value: false
      },
      {
        label: this.trueLable() ?? $localize`:@@on:An`,
        value: true
      }
    ];
  }

  public onValueChange(value: boolean): void {
    this.value = value;
    this.valueChange.emit(value);
  }
}